import { api } from 'utils';
import config from 'config';

const initCheckoutForm = ({ ip, user, merchantSiteId, merchantId, sessionToken, amount, onSubmit }) => {
  return new Promise(resolve => {
    const { uId, fNe, lNe, eml } = user;
    const { checkout } = window;
    checkout &&
      checkout({
        env: config.payment.env,
        showResponseMessage: true,
        merchantId,
        sessionToken,
        merchantSiteId,
        payButton: 'amountButton',
        savePM: true,
        pmWhitelist: ['cc_card', 'apmgw_expresscheckout', 'ppp_GooglePay', 'ppp_ApplePay'],
        renderTo: '#checkoutForm',
        userTokenId: uId,
        userId: uId,
        amount,
        locale: 'en',
        country: 'US',
        currency: 'USD',
        email: eml,
        fullName: `${fNe} ${lNe}`,
        deviceDetails: {
          ipAddress: ip,
        },
        billingAddress: {
          firstName: fNe,
          lastName: lNe,
          country: 'US',
          email: eml,
        },
        userDetails: {
          firstName: fNe,
          lastName: lNe,
          country: 'US',
          email: eml,
        },
        onReady: () => resolve({ sts: 's' }),
        onResult: onSubmit,
      });
  });
};

const createPaymenyInvoice = async data => {
  const { createPurchaseInvoice } = await api('POST', config.api.purchaseInvoice, data);
  return createPurchaseInvoice;
};

const getInvoiceStatus = async data => {
  const { getPurchaseInvoice } = await api('POST', config.api.invoiceStatus, data);
  return getPurchaseInvoice;
};

const service = {
  initCheckoutForm,
  createPaymenyInvoice,
  getInvoiceStatus,
};

export default service;
